// Variant mapping based on your Shopify data
window.bespokeHamperVariants = {
    '75_none': '53036264259918',
    '75_both': '53053288776014',
    '75_front': '53053288808782',
    '100_none': '53053288841550',
    '100_both': '53053288874318',
    '100_front': '53053288907086',
    '125_none': '53053288939854',
    '125_both': '53053288972622',
    '125_front': '53053289005390',
    '150_none': '53053289038158',
    '150_both': '53053289070926',
    '150_front': '53053289103694',
    '175_none': '53053289136462',
    '175_both': '53053289169230',
    '175_front': '53053289201998',
    '200_none': '53053289234766',
    '200_both': '53053289267534',
    '200_front': '53053289300302',
    '225_none': '53053289333070',
    '225_both': '53053289365838',
    '225_front': '53053289398606',
    '250_none': '53053289431374',
    '250_both': '53053289464142',
    '250_front': '53053289496910',
    '300_none': '53053289529678',
    '300_both': '53053289562446',
    '300_front': '53053289595214',
    '350_none': '53053289627982',
    '350_both': '53053289660750',
    '350_front': '53053289693518',
    '400_none': '53053289726286',
    '400_both': '53053289759054',
    '400_front': '53053289791822',
    '450_none': '53053289824590',
    '450_both': '53053289857358',
    '450_front': '53053289890126',
    '500_none': '53053289922894',
    '500_both': '53053289955662',
    '500_front': '53053289988430'
};


document.addEventListener('DOMContentLoaded', function() {
    // Elements
    const priceSelect = document.getElementById('price-select');
    const addRequirementsBtn = document.getElementById('add-requirements-btn');
    const initialView = document.getElementById('initial-view');
    const formView = document.getElementById('form-view');
    const form = document.getElementById('bespoke-form');
    const totalPriceSpan = document.getElementById('total-price');
    const successMessage = document.getElementById('success-message');
    const continueShoppingBtn = document.getElementById('continue-shopping-btn');

    // State
    let basePrice = 75;
    let currentStep = 1;

    // Form data storage
    let formData = {
        // Step 1
        senderName: '',
        senderEmail: '',
        senderCompany: '',
        giftingOccasion: '',
        employeeGifting: '',
        clientPartners: '',
        eventsSeasonal: '',
        personalCorporate: '',
        otherOccasion: '',
        hamperPreferences: '',
        alcoholSuitable: false,
        vatRegistered: false,
        vatNumber: '',
        // Step 2
        recipientName: '',
        deliveryCompany: '',
        deliveryRole: '',
        deliveryTrackingEmail: '',
        deliveryContactPhone: '',
        deliveryDate: '',
        deliveryAddress: '',
        deliveryAddress2: '',
        deliveryCity: '',
        deliveryPostcode: '',
        additionalDelivery: '',
        // Step 3
        giftTagTo: '',
        giftTagFrom: '',
        giftMessage: '',
        logoOnCard: false,
        packaging: '',
        packagingUpgradePrice: 0,
        logoOnBasket: false,
        logoOnBox: false,
        boxInsideMessage: '',
        logoUrl: '',
        logoName: '',
        // Step 4
        additionalNotes: ''
    };

    // Save progress to localStorage
    function saveProgress() {
        const progressData = {
            currentStep: currentStep,
            basePrice: basePrice,
            formData: formData,
            isFormStarted: formView.style.display !== 'none',
            timestamp: Date.now() // Add timestamp for prioritization
        };
        localStorage.setItem('bespokeHamperProgress', JSON.stringify(progressData));
    }

    // Load progress from localStorage
    function loadProgress() {
        const saved = localStorage.getItem('bespokeHamperProgress');
        if (saved) {
            try {
                const savedState = JSON.parse(saved);
                
                // Restore state variables
                if (savedState.currentStep) currentStep = savedState.currentStep;
                if (savedState.basePrice) basePrice = savedState.basePrice;
                if (savedState.formData) formData = { ...formData, ...savedState.formData };
                
                // Restore form UI if form was started
                if (savedState.isFormStarted) {
                    initialView.style.display = 'none';
                    formView.style.display = 'block';
                    showStep(currentStep);
                }
                
                // Restore form field values
                restoreFormFields();
                
                // Update price display
                priceSelect.value = basePrice;
                updateTotalPrice();
                
                console.log('Bespoke hamper progress loaded');
            } catch (e) {
                console.error('Error loading bespoke progress:', e);
                localStorage.removeItem('bespokeHamperProgress');
            }
        }
    }

    // Restore form field values from formData
    function restoreFormFields() {
        Object.keys(formData).forEach(key => {
            const element = document.getElementById(getFieldId(key));
            if (element) {
                // Handle checkboxes
                if (element.type === 'checkbox') {
                    element.checked = formData[key];
                } else if (formData[key]) {
                    element.value = formData[key];
                }
                
                // Handle special cases for gifting occasion
                if (key === 'giftingOccasion' && formData[key]) {
                    const employeeGiftingField = document.getElementById('employee-gifting-field');
                    const clientPartnersField = document.getElementById('client-partners-field');
                    const eventsSeasonalField = document.getElementById('events-seasonal-field');
                    const personalCorporateField = document.getElementById('personal-corporate-field');
                    const otherOccasionField = document.getElementById('other-occasion-field');
                    
                    if (formData[key] === 'employee-gifting') {
                        employeeGiftingField.classList.remove('hidden');
                    } else if (formData[key] === 'client-partners') {
                        clientPartnersField.classList.remove('hidden');
                    } else if (formData[key] === 'events-seasonal') {
                        eventsSeasonalField.classList.remove('hidden');
                    } else if (formData[key] === 'personal-corporate') {
                        personalCorporateField.classList.remove('hidden');
                    } else if (formData[key] === 'other') {
                        otherOccasionField.classList.remove('hidden');
                    }
                }
                
                // Handle "other" option in sub-dropdowns
                if ((key === 'employeeGifting' || key === 'clientPartners' || 
                     key === 'eventsSeasonal' || key === 'personalCorporate') && 
                    formData[key] === 'other') {
                    const otherOccasionField = document.getElementById('other-occasion-field');
                    if (otherOccasionField) {
                        otherOccasionField.classList.remove('hidden');
                    }
                }
                
                if (key === 'vatRegistered' && formData[key]) {
                    const vatNumberField = document.getElementById('vat-number-field');
                    if (vatNumberField) {
                        vatNumberField.classList.remove('hidden');
                    }
                }
                
                if (key === 'packaging' && formData[key]) {
                    // Trigger packaging UI updates
                    const event = new Event('change');
                    element.dispatchEvent(event);
                }
            }
        });
        
        // Restore logo preview if exists
        if (formData.logoUrl && formData.logoName) {
            const logoPreview = document.getElementById('logo-preview');
            if (logoPreview) {
                logoPreview.innerHTML = `
                    <div style="display:flex; gap:1rem; align-items:center; padding: 1rem; background: white; border-radius: 6px;">
                        <div style="flex:1;">
                            <img src="${formData.logoUrl}" alt="Logo preview" style="max-width:100%; max-height:160px; object-fit:contain; border:1px solid #eee; padding:6px; border-radius:6px;">
                        </div>
                        <div style="flex:0 0 auto;">
                            <button type="button" id="logo-remove-btn" class="button button--secondary" style="padding:.4rem .8rem;">Remove</button>
                        </div>
                    </div>
                `;
                
                const removeBtn = document.getElementById('logo-remove-btn');
                if (removeBtn) {
                    removeBtn.addEventListener('click', () => {
                        const logoFileInput = document.getElementById('logo-file');
                        if (logoFileInput) logoFileInput.value = '';
                        logoPreview.innerHTML = '';
                        formData.logoUrl = '';
                        formData.logoName = '';
                        saveProgress();
                    });
                }
            }
        }
    }

    // Helper function to map formData keys to field IDs
    function getFieldId(key) {
        const fieldMapping = {
            senderName: 'sender-name',
            senderEmail: 'sender-email',
            senderCompany: 'sender-company',
            giftingOccasion: 'gifting-occasion',
            employeeGifting: 'employee-gifting',
            clientPartners: 'client-partners',
            eventsSeasonal: 'events-seasonal',
            personalCorporate: 'personal-corporate',
            otherOccasion: 'other-occasion',
            hamperPreferences: 'hamper-preferences',
            alcoholSuitable: 'alcohol-suitable',
            vatRegistered: 'vat-registered',
            vatNumber: 'vat-number',
            recipientName: 'recipient-name',
            deliveryCompany: 'delivery-company',
            deliveryRole: 'delivery-role',
            deliveryTrackingEmail: 'delivery-tracking-email',
            deliveryContactPhone: 'delivery-contact-phone',
            deliveryDate: 'delivery-date',
            deliveryAddress: 'delivery-address',
            deliveryAddress2: 'delivery-address2',
            deliveryCity: 'delivery-city',
            deliveryPostcode: 'delivery-postcode',
            additionalDelivery: 'additional-delivery',
            giftTagTo: 'gift-tag-to',
            giftTagFrom: 'gift-tag-from',
            giftMessage: 'gift-message',
            logoOnCard: 'logo-on-card',
            packaging: 'packaging-select',
            logoOnBasket: 'logo-on-basket',
            logoOnBox: 'logo-on-box',
            boxInsideMessage: 'box-inside-message',
            additionalNotes: 'additional-notes'
        };
        return fieldMapping[key] || key;
    }

    // Price select handler
    priceSelect.addEventListener('change', function() {
        basePrice = parseInt(this.value);
        updateTotalPrice();
        saveProgress(); // Save progress when price changes
    });

    // Start form button
    addRequirementsBtn.addEventListener('click', function(e) {
        e.preventDefault();
        initialView.style.display = 'none';
        formView.style.display = 'block';
        window.scrollTo(0, 0);
        saveProgress(); // Save progress when form starts
    });

    // Handle gifting occasion dropdown and its sub-fields
    const giftingOccasionSelect = document.getElementById('gifting-occasion');
    const employeeGiftingField = document.getElementById('employee-gifting-field');
    const clientPartnersField = document.getElementById('client-partners-field');
    const eventsSeasonalField = document.getElementById('events-seasonal-field');
    const personalCorporateField = document.getElementById('personal-corporate-field');
    const otherOccasionField = document.getElementById('other-occasion-field');

    if (giftingOccasionSelect) {
        giftingOccasionSelect.addEventListener('change', function() {
            // Hide all sub-fields first
            employeeGiftingField.classList.add('hidden');
            clientPartnersField.classList.add('hidden');
            eventsSeasonalField.classList.add('hidden');
            personalCorporateField.classList.add('hidden');
            otherOccasionField.classList.add('hidden');

            // Show relevant sub-field based on selection
            if (this.value === 'employee-gifting') {
                employeeGiftingField.classList.remove('hidden');
            } else if (this.value === 'client-partners') {
                clientPartnersField.classList.remove('hidden');
            } else if (this.value === 'events-seasonal') {
                eventsSeasonalField.classList.remove('hidden');
            } else if (this.value === 'personal-corporate') {
                personalCorporateField.classList.remove('hidden');
            } else if (this.value === 'other') {
                otherOccasionField.classList.remove('hidden');
            }
            saveProgress();
        });
    }

    // Handle "other" option in sub-dropdowns
    const employeeGiftingSelect = document.getElementById('employee-gifting');
    const clientPartnersSelect = document.getElementById('client-partners');
    const eventsSeasonalSelect = document.getElementById('events-seasonal');
    const personalCorporateSelect = document.getElementById('personal-corporate');

    if (employeeGiftingSelect) {
        employeeGiftingSelect.addEventListener('change', function() {
            if (this.value === 'other') {
                otherOccasionField.classList.remove('hidden');
            } else if (giftingOccasionSelect.value !== 'other') {
                otherOccasionField.classList.add('hidden');
            }
            saveProgress();
        });
    }

    if (clientPartnersSelect) {
        clientPartnersSelect.addEventListener('change', function() {
            if (this.value === 'other') {
                otherOccasionField.classList.remove('hidden');
            } else if (giftingOccasionSelect.value !== 'other') {
                otherOccasionField.classList.add('hidden');
            }
            saveProgress();
        });
    }

    if (eventsSeasonalSelect) {
        eventsSeasonalSelect.addEventListener('change', function() {
            if (this.value === 'other') {
                otherOccasionField.classList.remove('hidden');
            } else if (giftingOccasionSelect.value !== 'other') {
                otherOccasionField.classList.add('hidden');
            }
            saveProgress();
        });
    }

    if (personalCorporateSelect) {
        personalCorporateSelect.addEventListener('change', function() {
            if (this.value === 'other') {
                otherOccasionField.classList.remove('hidden');
            } else if (giftingOccasionSelect.value !== 'other') {
                otherOccasionField.classList.add('hidden');
            }
            saveProgress();
        });
    }

    // Handle VAT registration checkbox
    const vatCheckbox = document.getElementById('vat-registered');
    const vatNumberField = document.getElementById('vat-number-field');

    if (vatCheckbox && vatNumberField) {
        vatCheckbox.addEventListener('change', function() {
            if (this.checked) {
                vatNumberField.classList.remove('hidden');
            } else {
                vatNumberField.classList.add('hidden');
            }
            saveProgress();
        });
    }

    // Handle packaging selection
    const packagingSelect = document.getElementById('packaging-select');
    const basketLogoField = document.getElementById('basket-logo-field');
    const boxLogoField = document.getElementById('box-logo-field');
    const boxInsideMessageField = document.getElementById('box-inside-message-field');

    if (packagingSelect && basketLogoField && boxLogoField) {
        packagingSelect.addEventListener('change', function() {
            const selectedOption = this.options[this.selectedIndex];
            const packagingPrice = parseFloat(selectedOption.dataset.price) || 0;
            formData.packagingUpgradePrice = packagingPrice;

            if (this.value === 'light-basket' || this.value === 'dark-basket') {
                basketLogoField.classList.remove('hidden');
                boxLogoField.classList.add('hidden');
                if (boxInsideMessageField) {
                    boxInsideMessageField.classList.add('hidden');
                }
            } else if (this.value === 'luxury-box') {
                basketLogoField.classList.add('hidden');
                boxLogoField.classList.remove('hidden');
                if (boxInsideMessageField) {
                    boxInsideMessageField.classList.remove('hidden');
                }
            } else {
                basketLogoField.classList.add('hidden');
                boxLogoField.classList.add('hidden');
                if (boxInsideMessageField) {
                    boxInsideMessageField.classList.add('hidden');
                }
            }
            
            updateTotalPrice();
            saveProgress();
        });
    }

    // Handle logo file upload
    const logoFileInput = document.getElementById('logo-file');
    const logoPreview = document.getElementById('logo-preview');

    if (logoFileInput && logoPreview) {
        logoFileInput.addEventListener('change', function(e) {
            const file = e.target.files && e.target.files[0];

            if (!file) {
                logoPreview.innerHTML = '';
                formData.logoUrl = '';
                formData.logoName = '';
                saveProgress();
                return;
            }

            if (!file.type || !file.type.startsWith('image/')) {
                alert('Please upload an image file (PNG, JPG, SVG etc.).');
                logoFileInput.value = '';
                logoPreview.innerHTML = '';
                formData.logoUrl = '';
                formData.logoName = '';
                saveProgress();
                return;
            }

            // Show loading indicator
            logoPreview.innerHTML = `<div style="color:#888; padding: 1rem;">Uploading logo...</div>`;

            // Cloudinary upload
            const cloudName = 'da5cktdv2';
            const uploadPreset = 'tophampers';

            const formDataUpload = new FormData();
            formDataUpload.append('file', file);
            formDataUpload.append('upload_preset', uploadPreset);

            fetch(`https://api.cloudinary.com/v1_1/${cloudName}/image/upload`, {
                method: 'POST',
                body: formDataUpload
            })
            .then(res => res.json())
            .then(data => {
                if (data.secure_url) {
                    formData.logoUrl = data.secure_url;
                    formData.logoName = file.name;

                    logoPreview.innerHTML = `
                        <div style="display:flex; gap:1rem; align-items:center; padding: 1rem; background: white; border-radius: 6px;">
                            <div style="flex:1;">
                                <img src="${data.secure_url}" alt="Logo preview" style="max-width:100%; max-height:160px; object-fit:contain; border:1px solid #eee; padding:6px; border-radius:6px;">
                            </div>
                            <div style="flex:0 0 auto;">
                                <button type="button" id="logo-remove-btn" class="button button--secondary" style="padding:.4rem .8rem;">Remove</button>
                            </div>
                        </div>
                    `;

                    const removeBtn = document.getElementById('logo-remove-btn');
                    if (removeBtn) {
                        removeBtn.addEventListener('click', () => {
                            logoFileInput.value = '';
                            logoPreview.innerHTML = '';
                            formData.logoUrl = '';
                            formData.logoName = '';
                            saveProgress();
                        });
                    }

                    saveProgress();
                } else {
                    alert('Logo upload failed. Please try again.');
                    logoPreview.innerHTML = '';
                    formData.logoUrl = '';
                    formData.logoName = '';
                }
            })
            .catch(() => {
                alert('Logo upload failed. Please try again.');
                logoPreview.innerHTML = '';
                formData.logoUrl = '';
                formData.logoName = '';
            });
        });
    }

    // Add auto-save listeners to all form fields
    function addAutoSaveListeners() {
        const formFields = [
            'sender-name', 'sender-email', 'sender-company', 'relationship', 'other-relationship',
            'occasion', 'other-occasion', 'hamper-preferences', 'alcohol-suitable',
            'vat-registered', 'vat-number', 'recipient-name', 'delivery-company', 'delivery-role',
            'delivery-tracking-email', 'sender-phone', 'delivery-date', 'delivery-address', 
            'delivery-address2', 'delivery-city', 'delivery-postcode', 'additional-delivery',
            'gift-tag-to', 'gift-tag-from', 'gift-message', 'logo-on-card', 'packaging-select',
            'logo-on-basket', 'logo-on-box', 'box-inside-message', 'additional-notes'
        ];

        formFields.forEach(fieldId => {
            const field = document.getElementById(fieldId);
            if (field) {
                field.addEventListener('input', () => {
                    // Debounce the save to avoid excessive localStorage writes
                    clearTimeout(window.bespokeAutoSaveTimeout);
                    window.bespokeAutoSaveTimeout = setTimeout(saveProgress, 1000);
                });
                
                field.addEventListener('change', saveProgress);
            }
        });
    }

    // Call auto-save setup
    addAutoSaveListeners();

    // Step navigation functions
      function showStep(stepNumber) {
      console.log('Attempting to show step:', stepNumber);
      
      // Get all FORM steps (not progress indicators)
      const allSteps = document.querySelectorAll('.bespoke-form__step[data-step]');
      
      // Hide all steps
      allSteps.forEach(step => {
          step.classList.remove('bespoke-form__step--active');
          // Remove any inline styles
          step.style.display = '';
          step.style.visibility = '';
          step.style.opacity = '';
      });
      
      // Find and show the target step - be more specific
      const targetStep = document.querySelector(`.bespoke-form__step[data-step="${stepNumber}"]`);
      
      if (targetStep) {
          // Add active class
          targetStep.classList.add('bespoke-form__step--active');
          
          // Log the correct element info
          console.log('Step element found:', targetStep);
          console.log('Step classes:', targetStep.className);
          
          // Force visibility with inline styles as backup
          targetStep.style.display = 'block';
          targetStep.style.visibility = 'visible';
          targetStep.style.opacity = '1';
          
          console.log('Step activated:', stepNumber);
      } else {
          console.error('Step element not found for step:', stepNumber);
          // Debug: show what elements were found
          console.log('Elements with data-step:', document.querySelectorAll(`[data-step="${stepNumber}"]`));
      }
      
      // Update progress indicators separately
      updateProgressSteps(stepNumber);
      
      currentStep = stepNumber;
      
      // Update summary if on step 4
      if (stepNumber === 4) {
          updateSummary();
      }
      
      // Scroll to top of form
      formView.scrollIntoView({ behavior: 'smooth' });
  }
  
  // Ensure progress steps update uses different selector
  function updateProgressSteps(stepNumber) {
      // Target only the progress indicator items, not form steps
      document.querySelectorAll('.progress-steps .step-item').forEach((item, index) => {
          if (index < stepNumber - 1) {
              item.classList.add('completed');
              item.classList.remove('active');
          } else if (index === stepNumber - 1) {
              item.classList.add('active');
              item.classList.remove('completed');
          } else {
              item.classList.remove('active', 'completed');
          }
      });
  }

    function saveStepData(stepNumber) {
        switch(stepNumber) {
            case 1:
                formData.senderName = document.getElementById('sender-name').value;
                formData.senderEmail = document.getElementById('sender-email').value;
                formData.senderCompany = document.getElementById('sender-company').value;
                formData.giftingOccasion = document.getElementById('gifting-occasion').value;
                const employeeGiftingEl = document.getElementById('employee-gifting');
                formData.employeeGifting = employeeGiftingEl ? employeeGiftingEl.value : '';
                const clientPartnersEl = document.getElementById('client-partners');
                formData.clientPartners = clientPartnersEl ? clientPartnersEl.value : '';
                const eventsSeasonalEl = document.getElementById('events-seasonal');
                formData.eventsSeasonal = eventsSeasonalEl ? eventsSeasonalEl.value : '';
                const personalCorporateEl = document.getElementById('personal-corporate');
                formData.personalCorporate = personalCorporateEl ? personalCorporateEl.value : '';
                const otherOccasionEl = document.getElementById('other-occasion');
                formData.otherOccasion = otherOccasionEl ? otherOccasionEl.value : '';
                formData.hamperPreferences = document.getElementById('hamper-preferences').value;
                formData.alcoholSuitable = document.getElementById('alcohol-suitable').checked;
                formData.vatRegistered = document.getElementById('vat-registered').checked;
                const vatNumberEl = document.getElementById('vat-number');
                formData.vatNumber = vatNumberEl ? vatNumberEl.value : '';
                break;
            case 2:
                formData.giftTagTo = document.getElementById('gift-tag-to').value;
                formData.giftTagFrom = document.getElementById('gift-tag-from').value;
                formData.giftMessage = document.getElementById('gift-message').value;
                formData.logoOnCard = document.getElementById('logo-on-card').checked;
                formData.packaging = document.getElementById('packaging-select').value;
                const logoOnBasketEl = document.getElementById('logo-on-basket');
                const logoOnBoxEl = document.getElementById('logo-on-box');
                formData.logoOnBasket = logoOnBasketEl ? logoOnBasketEl.checked : false;
                formData.logoOnBox = logoOnBoxEl ? logoOnBoxEl.checked : false;
                formData.boxInsideMessage = document.getElementById('box-inside-message').value;
                break;
            case 3:
                formData.recipientName = document.getElementById('recipient-name').value;
                formData.deliveryCompany = document.getElementById('delivery-company').value;
                const deliveryRoleEl = document.getElementById('delivery-role');
                formData.deliveryRole = deliveryRoleEl ? deliveryRoleEl.value : '';
                formData.deliveryTrackingEmail = document.getElementById('delivery-tracking-email').value;
                const deliveryContactPhoneEl = document.getElementById('delivery-contact-phone');
                formData.deliveryContactPhone = deliveryContactPhoneEl ? deliveryContactPhoneEl.value : '';
                formData.deliveryDate = document.getElementById('delivery-date').value;
                formData.deliveryAddress = document.getElementById('delivery-address').value;
                formData.deliveryAddress2 = document.getElementById('delivery-address2').value;
                formData.deliveryCity = document.getElementById('delivery-city').value;
                formData.deliveryPostcode = document.getElementById('delivery-postcode').value;
                formData.additionalDelivery = document.getElementById('additional-delivery').value;
                break;
            case 4:
                formData.additionalNotes = document.getElementById('additional-notes').value;
                break;
        }
        saveProgress(); // Save progress after updating formData
    }

    function validateStep(stepNumber) {
        switch(stepNumber) {
            case 1:
                const senderName = document.getElementById('sender-name').value;
                const senderEmail = document.getElementById('sender-email').value;
                const senderCompany = document.getElementById('sender-company').value;
                const giftingOccasion = document.getElementById('gifting-occasion').value;

                if (!senderName.trim()) {
                    alert('Please enter your name');
                    return false;
                }
                if (!senderEmail.trim()) {
                    alert('Please enter your email address');
                    return false;
                }
                if (!senderCompany.trim()) {
                    alert('Please enter your company name');
                    return false;
                }
                if (!giftingOccasion) {
                    alert('Please select a gifting occasion');
                    return false;
                }
                return true;

            case 2:
                const giftTagTo = document.getElementById('gift-tag-to').value;
                const giftTagFrom = document.getElementById('gift-tag-from').value;
                const packaging = document.getElementById('packaging-select').value;

                if (!giftTagTo.trim()) {
                    alert('Please enter who the gift tag is to');
                    return false;
                }
                if (!giftTagFrom.trim()) {
                    alert('Please enter who the gift tag is from');
                    return false;
                }
                if (!packaging) {
                    alert('Please select a packaging option');
                    return false;
                }
                // Box inside message is only required if luxury-box is selected
                if (packaging === 'luxury-box') {
                    const boxInsideMessage = document.getElementById('box-inside-message').value;
                    if (!boxInsideMessage.trim()) {
                        alert('Please enter a message for the inside of the box');
                        return false;
                    }
                }
                return true;

            case 3:
                const recipientName = document.getElementById('recipient-name').value;
                const deliveryCompany = document.getElementById('delivery-company').value;
                const deliveryTrackingEmail = document.getElementById('delivery-tracking-email').value;
                const deliveryDate = document.getElementById('delivery-date').value;
                const deliveryAddress = document.getElementById('delivery-address').value;
                const deliveryAddress2 = document.getElementById('delivery-address2').value;
                const deliveryCity = document.getElementById('delivery-city').value;
                const deliveryPostcode = document.getElementById('delivery-postcode').value;

                if (!recipientName.trim()) {
                    alert('Please enter the recipient name');
                    return false;
                }
                if (!deliveryCompany.trim()) {
                    alert('Please enter the delivery company name');
                    return false;
                }
                if (!deliveryTrackingEmail.trim()) {
                    alert('Please provide an email for tracking');
                    return false;
                }
                if (!deliveryDate) {
                    alert('Please select a delivery date');
                    return false;
                }
                if (!deliveryAddress.trim() || !deliveryAddress2.trim() || !deliveryCity.trim() || !deliveryPostcode.trim()) {
                    alert('Please complete all required delivery address fields');
                    return false;
                }

                return true;

            default:
                return true;
        }
    }

    // Step navigation buttons
    document.getElementById('continue-to-step2').addEventListener('click', function() {
        if (validateStep(1)) {
            saveStepData(1);
            showStep(2);
        }
    });

    document.getElementById('continue-to-step3').addEventListener('click', function() {
        if (validateStep(2)) {
            saveStepData(2);
            showStep(3);
        }
    });

    document.getElementById('continue-to-step4').addEventListener('click', function() {
        if (validateStep(3)) {
            saveStepData(3);
            showStep(4);
        }
    });

 // Back button navigation
function goToPreviousStep() {
    if (currentStep === 1) {
        // Go back to initial price selection view
        formView.style.display = 'none';
        initialView.style.display = 'block';
        window.scrollTo(0, 0);
    } else if (currentStep > 1) {
        // Go to previous form step
        showStep(currentStep - 1);
    }
}

// Add event listeners for back buttons
document.addEventListener('click', function(e) {
    if (e.target.classList.contains('back-to-step') || e.target.closest('.back-to-step')) {
        e.preventDefault();
        goToPreviousStep();
    }
});

    // Update total price
    function updateTotalPrice() {
        const total = basePrice + formData.packagingUpgradePrice;
        totalPriceSpan.textContent = `£${total.toFixed(2)}`;
    }

    // Update summary
    function updateSummary() {
        const summaryContent = document.getElementById('summary-content');
        const packagingText = getDisplayText('packaging', formData.packaging);

        let summaryHtml = `
            <p><strong>Bespoke Hamper (£${basePrice})</strong></p>
            <p>${packagingText}</p>
        `;

        if (formData.packagingUpgradePrice > 0) {
            summaryHtml += `<p>Packaging Upgrade: +£${formData.packagingUpgradePrice.toFixed(2)}</p>`;
        }

        summaryContent.innerHTML = summaryHtml;
        updateTotalPrice();
    }

    // Helper function to get display text for values
    function getDisplayText(field, value) {
        const displayMappings = {
            packaging: {
                'luxury-box': 'Luxury Magnetic Gift Box',
                'light-basket': 'Light Wicker Basket (+£10)',
                'dark-basket': 'Dark Wicker Basket (+£10)'
            }
        };

        return displayMappings[field] && displayMappings[field][value] ? displayMappings[field][value] : value;
    }

    // Form submission
    form.addEventListener('submit', async function(e) {
        e.preventDefault();

        // Save step 4 data
        saveStepData(4);

        const submitButton = document.getElementById('add-to-basket-btn');
        const originalButtonText = submitButton.innerHTML;

        // Show loading state
        submitButton.disabled = true;
        submitButton.innerHTML = 'Adding to basket...';

        // Collect all form data
        const finalFormData = {
            price: basePrice,
            ...formData,
            packagingDisplay: getDisplayText('packaging', formData.packaging),
            totalPrice: basePrice + formData.packagingUpgradePrice
        };

        // Create product and add to cart
        try {
            // Add to cart
            await addToCart(finalFormData);

            // Show success message
            formView.style.display = 'none';
            successMessage.style.display = 'block';
            window.scrollTo(0, 0);

            // Clear progress from localStorage since form is completed
            localStorage.removeItem('bespokeHamperProgress');

            // Reset button
            submitButton.disabled = false;
            submitButton.innerHTML = originalButtonText;

        } catch (error) {
            console.error('Error adding to cart:', error);
            alert('There was an error adding your item to the cart. Please try again.');

            // Reset button
            submitButton.disabled = false;
            submitButton.innerHTML = originalButtonText;
        }
    });

    // Continue shopping
    continueShoppingBtn.addEventListener('click', function() {
        // Clear progress from localStorage
        localStorage.removeItem('bespokeHamperProgress');
        
        // Reset everything
        form.reset();
        successMessage.style.display = 'none';
        initialView.style.display = 'block';
        formView.style.display = 'none';
        
        // Reset to step 1
        showStep(1);
        
        // Reset state - hide all conditional fields
        const employeeGiftingField = document.getElementById('employee-gifting-field');
        const clientPartnersField = document.getElementById('client-partners-field');
        const eventsSeasonalField = document.getElementById('events-seasonal-field');
        const personalCorporateField = document.getElementById('personal-corporate-field');
        const otherOccasionField = document.getElementById('other-occasion-field');
        const vatNumberField = document.getElementById('vat-number-field');
        const basketLogoField = document.getElementById('basket-logo-field');
        const boxLogoField = document.getElementById('box-logo-field');
        
        if (employeeGiftingField) employeeGiftingField.classList.add('hidden');
        if (clientPartnersField) clientPartnersField.classList.add('hidden');
        if (eventsSeasonalField) eventsSeasonalField.classList.add('hidden');
        if (personalCorporateField) personalCorporateField.classList.add('hidden');
        if (otherOccasionField) otherOccasionField.classList.add('hidden');
        if (vatNumberField) vatNumberField.classList.add('hidden');
        if (basketLogoField) basketLogoField.classList.add('hidden');
        if (boxLogoField) boxLogoField.classList.add('hidden');
        const logoPreview = document.getElementById('logo-preview');
        if (logoPreview) logoPreview.innerHTML = '';
        updateTotalPrice();

        // Reset form data
        formData = {
            senderName: '',
            senderEmail: '',
            senderCompany: '',
            relationship: '',
            otherRelationship: '',
            occasion: '',
            otherOccasion: '',
            hamperPreferences: '',
            alcoholSuitable: false,
            vatRegistered: false,
            vatNumber: '',
            recipientName: '',
            deliveryCompany: '',
            deliveryRole: '',
            deliveryTrackingEmail: '',
            senderPhone: '',
            deliveryDate: '',
            deliveryAddress: '',
            deliveryAddress2: '',
            deliveryCity: '',
            deliveryPostcode: '',
            additionalDelivery: '',
            giftTagTo: '',
            giftTagFrom: '',
            giftMessage: '',
            logoOnCard: false,
            packaging: '',
            packagingUpgradePrice: 0,
            logoOnBasket: false,
            logoOnBox: false,
            boxInsideMessage: '',
            logoUrl: '',
            logoName: '',
            additionalNotes: ''
        };

        window.scrollTo(0, 0);
    });

    async function addToCart(formData) {
        // Build the variant key based on base price only (packaging is handled as upgrade)
        // We'll use 'none' for all variants since personalisation is removed
        const variantKey = `${formData.price}_none`;

        // Get the correct variant ID
        const variantId = window.bespokeHamperVariants[variantKey];

        if (!variantId) {
            // Handle missing variants
            console.error('No variant found for:', variantKey);
            alert('This price combination is not available. Please contact us for assistance.');
            return;
        }

        // Build properties object with all custom data
        const properties = {};

        // Step 1 data
        properties['Sender Name'] = formData.senderName;
        properties['Sender Email'] = formData.senderEmail;
        properties['Company Name'] = formData.senderCompany;
        
        // Gifting occasion and sub-categories
        if (formData.giftingOccasion) {
            let occasionDisplay = formData.giftingOccasion;
            let subCategory = '';
            
            if (formData.giftingOccasion === 'employee-gifting' && formData.employeeGifting) {
                subCategory = formData.employeeGifting === 'other' ? formData.otherOccasion : formData.employeeGifting;
            } else if (formData.giftingOccasion === 'client-partners' && formData.clientPartners) {
                subCategory = formData.clientPartners === 'other' ? formData.otherOccasion : formData.clientPartners;
            } else if (formData.giftingOccasion === 'events-seasonal' && formData.eventsSeasonal) {
                subCategory = formData.eventsSeasonal === 'other' ? formData.otherOccasion : formData.eventsSeasonal;
            } else if (formData.giftingOccasion === 'personal-corporate' && formData.personalCorporate) {
                subCategory = formData.personalCorporate === 'other' ? formData.otherOccasion : formData.personalCorporate;
            } else if (formData.giftingOccasion === 'other' && formData.otherOccasion) {
                subCategory = formData.otherOccasion;
            }
            
            properties['Gifting Occasion'] = occasionDisplay;
            if (subCategory) properties['Occasion Details'] = subCategory;
        }
        
        if (formData.hamperPreferences) properties['Hamper Preferences'] = formData.hamperPreferences;
        properties['Alcohol Suitable'] = formData.alcoholSuitable ? 'Yes' : 'No';
        
        if (formData.vatRegistered) {
            properties['VAT Registered'] = 'Yes';
            if (formData.vatNumber) properties['VAT Number'] = formData.vatNumber;
        }

        // Step 2 data
        properties['Recipient Name'] = formData.recipientName;
        properties['Delivery Company'] = formData.deliveryCompany;
        if (formData.deliveryRole) properties['Role/Department'] = formData.deliveryRole;
        properties['Tracking Email'] = formData.deliveryTrackingEmail;
        if (formData.deliveryContactPhone) properties['Tracking Phone'] = formData.deliveryContactPhone;
        properties['Delivery Date'] = formData.deliveryDate;
        properties['Delivery Address'] = formData.deliveryAddress;
        properties['Delivery Address 2'] = formData.deliveryAddress2;
        properties['Delivery City'] = formData.deliveryCity;
        properties['Delivery Postcode'] = formData.deliveryPostcode;
        if (formData.additionalDelivery) properties['Additional Delivery Info'] = formData.additionalDelivery;

        // Step 3 data
        properties['Packaging'] = formData.packagingDisplay;
        if (formData.packagingUpgradePrice > 0) {
            properties['Packaging Upgrade'] = `+£${formData.packagingUpgradePrice.toFixed(2)}`;
        }
        properties['Gift Tag To'] = formData.giftTagTo;
        properties['Gift Tag From'] = formData.giftTagFrom;
        if (formData.giftMessage) properties['Gift Message'] = formData.giftMessage;
        properties['Logo On Card'] = formData.logoOnCard ? 'Yes' : 'No';
        if (formData.logoOnBasket) properties['Logo On Basket Liner'] = 'Yes';
        if (formData.logoOnBox) properties['Logo On Box'] = 'Yes';
        properties['Box Inside Message'] = formData.boxInsideMessage;
        if (formData.logoUrl) {
            properties['Logo URL'] = formData.logoUrl;
            properties['Logo Filename'] = formData.logoName;
        }

        // Step 4 data
        if (formData.additionalNotes) properties['Additional Notes'] = formData.additionalNotes;

        // Create the items array - add base hamper
        const items = [{
            id: variantId,
            quantity: 1,
            properties: properties
        }];

        // Add packaging upgrade as separate line item if needed
        if (formData.packagingUpgradePrice > 0 && formData.packaging && (formData.packaging === 'light-basket' || formData.packaging === 'dark-basket')) {
            // You'll need to provide a variant ID for the packaging upgrade
            // For now, we'll include it in properties only
            // If you want it as a separate line item, add another item here
        }

        const cartData = { items };

        try {
            const response = await fetch('/cart/add.js', {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                    'Accept': 'application/json'
                },
                body: JSON.stringify(cartData)
            });

            if (!response.ok) {
                const errorData = await response.json();
                console.error('Cart API Error:', errorData);

                if (errorData.status === 422) {
                    throw new Error('Product variant not found. Please check the variant ID is correct.');
                }
                throw new Error(errorData.description || 'Failed to add to cart');
            }

            const result = await response.json();

            // Update cart count in header
            updateCartUI();

            // Trigger Shopify cart update events
            document.dispatchEvent(new CustomEvent('cart:updated', {
                detail: { cart: result }
            }));

            // Try to open cart drawer if it exists
            if (typeof window.Shopify !== 'undefined' && window.Shopify.theme && window.Shopify.theme.openCartDrawer) {
                window.Shopify.theme.openCartDrawer();
            } else if (document.querySelector('.js-drawer-open-right')) {
                document.querySelector('.js-drawer-open-right').click();
            }

            return result;
        } catch (error) {
            console.error('Add to cart error:', error);
            throw error;
        }
    }

    // Gallery functionality
    const thumbnails = document.querySelectorAll('.thumbnail');
    const mainImage = document.querySelector('.bespoke-hampers__main-image img');
    const prevButton = document.querySelector('.image-nav__button--prev');
    const nextButton = document.querySelector('.image-nav__button--next');
    let currentImageIndex = 0;

    // Array of main images (using the window.bespokeHamperImages from Liquid)
    const images = window.bespokeHamperImages || [];

    // Function to update the main image
    function updateMainImage(index) {
        if (mainImage && images[index]) {
            mainImage.src = images[index];
            // Update active thumbnail
            thumbnails.forEach((thumb, i) => {
                if (i === index) {
                    thumb.classList.add('active');
                } else {
                    thumb.classList.remove('active');
                }
            });
            currentImageIndex = index;
        }
    }

    // Thumbnail click handlers
    thumbnails.forEach((thumb, index) => {
        thumb.addEventListener('click', function() {
            updateMainImage(index);
        });
    });

    // Navigation arrow handlers
    if (prevButton) {
        prevButton.addEventListener('click', function() {
            let newIndex = currentImageIndex - 1;
            if (newIndex < 0) {
                newIndex = images.length - 1; // Loop to last image
            }
            updateMainImage(newIndex);
        });
    }

    if (nextButton) {
        nextButton.addEventListener('click', function() {
            let newIndex = currentImageIndex + 1;
            if (newIndex >= images.length) {
                newIndex = 0; // Loop to first image
            }
            updateMainImage(newIndex);
        });
    }

    // Mobile gallery functionality
    function initMobileGallery() {
        // Check if we're on mobile
        if (window.innerWidth > 749) return;

        const mainImageContainer = document.querySelector('.bespoke-hampers__main-image');
        if (!mainImageContainer) return;

        // Check if mobile gallery is already initialized
        if (mainImageContainer.querySelector('.bespoke-hampers__image-wrapper')) {
            return; // Already initialized, don't create duplicates
        }

        const images = window.bespokeHamperImages || [];

        // Remove any existing dots first
        const existingDots = document.querySelector('.bespoke-hampers__dots');
        if (existingDots) {
            existingDots.remove();
        }

        // Create wrapper for images
        const imageWrapper = document.createElement('div');
        imageWrapper.className = 'bespoke-hampers__image-wrapper';

        // Clear existing content
        mainImageContainer.innerHTML = '';

        // Add all images to wrapper
        images.forEach((imageSrc, index) => {
            const imageItem = document.createElement('div');
            imageItem.className = 'bespoke-hampers__image-item';
            imageItem.innerHTML = `<img src="${imageSrc}" alt="Bespoke Hamper ${index + 1}" />`;
            imageWrapper.appendChild(imageItem);
        });

        mainImageContainer.appendChild(imageWrapper);

        // Create dot indicators
        const dotsContainer = document.createElement('div');
        dotsContainer.className = 'bespoke-hampers__dots';

        images.forEach((_, index) => {
            const dot = document.createElement('span');
            dot.className = 'dot-indicator' + (index === 0 ? ' active' : '');
            dot.dataset.index = index;
            dotsContainer.appendChild(dot);
        });

        // Insert dots after gallery
        mainImageContainer.parentElement.appendChild(dotsContainer);

        // Handle scroll events to update active dot
        let scrollTimeout;
        mainImageContainer.addEventListener('scroll', function() {
            clearTimeout(scrollTimeout);
            scrollTimeout = setTimeout(() => {
                const scrollLeft = mainImageContainer.scrollLeft;
                const itemWidth = mainImageContainer.querySelector('.bespoke-hampers__image-item').offsetWidth + 16; // width + gap
                const activeIndex = Math.round(scrollLeft / itemWidth);

                // Update active dot
                document.querySelectorAll('.dot-indicator').forEach((dot, index) => {
                    dot.classList.toggle('active', index === activeIndex);
                });
            }, 100);
        });

        // Handle dot clicks
        dotsContainer.addEventListener('click', function(e) {
            if (e.target.classList.contains('dot-indicator')) {
                const index = parseInt(e.target.dataset.index);
                const itemWidth = mainImageContainer.querySelector('.bespoke-hampers__image-item').offsetWidth + 16;
                mainImageContainer.scrollTo({
                    left: index * itemWidth,
                    behavior: 'smooth'
                });
            }
        });
    }

    // Function to clean up mobile gallery elements
    function cleanupMobileGallery() {
        // Remove dots if they exist
        const existingDots = document.querySelector('.bespoke-hampers__dots');
        if (existingDots) {
            existingDots.remove();
        }
    }

    // Initialize mobile gallery on load
    initMobileGallery();

    // Reinitialize on window resize with better debouncing
    let resizeTimeout;
    let lastWidth = window.innerWidth;
    
    window.addEventListener('resize', function() {
        clearTimeout(resizeTimeout);
        resizeTimeout = setTimeout(() => {
            // Only reinitialize if width actually changed significantly (prevents iOS scroll resize events)
            const currentWidth = window.innerWidth;
            if (Math.abs(currentWidth - lastWidth) < 10) {
                return; // Skip if width change is minimal (likely iOS scroll behavior)
            }
            lastWidth = currentWidth;
            
            // Reset gallery based on screen size
            const mainImageContainer = document.querySelector('.bespoke-hampers__main-image');
            if (!mainImageContainer) return;

            if (window.innerWidth <= 749) {
                // Clean up any existing elements before reinitializing
                cleanupMobileGallery();
                initMobileGallery();
            } else {
                // Clean up mobile gallery elements
                cleanupMobileGallery();
                
                // Restore desktop gallery
                mainImageContainer.innerHTML = `<img src="${images[currentImageIndex]}" alt="Bespoke Hamper" />
                <div class="image-nav">
                    <button class="image-nav__button image-nav__button--prev" aria-label="Previous image">
                        <svg width="24" height="24" viewBox="0 0 24 24" fill="none">
                            <path d="M15 18L9 12L15 6" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                        </svg>
                    </button>
                    <button class="image-nav__button image-nav__button--next" aria-label="Next image">
                        <svg width="24" height="24" viewBox="0 0 24 24" fill="none">
                            <path d="M9 18L15 12L9 6" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                        </svg>
                    </button>
                </div>`;

                // Remove dots if they exist
                const dots = document.querySelector('.bespoke-hampers__dots');
                if (dots) dots.remove();

                // Reattach desktop event listeners
                const prevButton = document.querySelector('.image-nav__button--prev');
                const nextButton = document.querySelector('.image-nav__button--next');
                if (prevButton && nextButton) {
                    prevButton.addEventListener('click', function() {
                        let newIndex = currentImageIndex - 1;
                        if (newIndex < 0) newIndex = images.length - 1;
                        updateMainImage(newIndex);
                    });

                    nextButton.addEventListener('click', function() {
                        let newIndex = currentImageIndex + 1;
                        if (newIndex >= images.length) newIndex = 0;
                        updateMainImage(newIndex);
                    });
                }
            }
        }, 250);
    });

    // Update cart UI function
    async function updateCartUI() {
        try {
            // Fetch current cart to get item count
            const response = await fetch('/cart.js');
            const cart = await response.json();

            // Update cart count in header - common selectors
            const cartCountSelectors = [
                '.cart-count',
                '.cart-count-bubble',
                '.js-cart-count',
                '[data-cart-count]',
                '.site-header__cart-count',
                '.header__cart-count',
                '#CartCount'
            ];

            cartCountSelectors.forEach(selector => {
                const elements = document.querySelectorAll(selector);
                elements.forEach(el => {
                    el.textContent = cart.item_count;
                    // Remove hidden class if count > 0
                    if (cart.item_count > 0) {
                        el.classList.remove('hidden', 'hide');
                    }
                });
            });

            // Update cart icon badge attributes
            document.querySelectorAll('[data-cart-count]').forEach(el => {
                el.setAttribute('data-cart-count', cart.item_count);
            });

        } catch (error) {
            console.error('Error updating cart UI:', error);
        }
    }


    // Initialize
    updateTotalPrice();
    
    // Load progress on page load
    loadProgress();
});
